import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';

import {
  NODE_ENV,
  RELEASE_VERSION,
  SENTRY_DSN,
  SENTRY_ENABLED,
  SENTRY_ENVIRONMENT,
  SENTRY_MASK_ALL_TEXT,
} from './config';

const isProduction = NODE_ENV === 'production';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  enabled: SENTRY_ENABLED, // Enable Sentry in production; disable in development
  release: RELEASE_VERSION, // Release version for tracking
  debug: !isProduction, // Enable debug logging in development

  // Set up integrations based on environment and needs
  integrations: [
    // Integration for React Router V6, enabling tracing on route changes
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),

    // Replay Integration: Used to capture user sessions and replay interactions
    Sentry.replayIntegration({
      maskAllText: SENTRY_MASK_ALL_TEXT,
      maskAllInputs: SENTRY_MASK_ALL_TEXT,
    }),
  ],

  // Set tracesSampleRate to control percentage of transactions for tracing
  tracesSampleRate: 1,

  // Define URLs and paths for which trace propagation should be enabled
  tracePropagationTargets: [
    /^\//, // Any path on the current domain
    /^https?:\/\/.*\.asset-metrix\.(com|io)\/portal-gateway\//, // Portal Gateway API endpoints
  ],

  // Configure replay session sampling rates
  replaysSessionSampleRate: 0, // Capture 0% of all the sessions (we're only interested in replays of sessions with errors hence 0)
  replaysOnErrorSampleRate: 1, // Capture 100% of sessions during errors
});
